export default __webpack_public_path__ + "static/media/Plafondinductie-units.13971ebb.png";